import logger from './utils/logger.js';

// index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import store from './store';
import App from './App';
import Interview from './pages/Interview';
import './index.css';
import InterviewForm from './InterviewForm';
import ThankYou from './ThankYou';
import InterviewFeedback from './InterviewFeedback';
import InterviewCompleted from './pages/Interview/components/InterviewCompleted';
import WebSocketProvider from './WebSocketContext';
import { ToastContainer } from './components/Toast';
import CodeEditor from './CodeEditorComponent/components/CodeEditor';
import ReactLiveCodeEditor from './ReactLiveCodeEditor';
import SecondryCamera from './SecondryCamera';
import InterviewFormStep1 from './InterviewFormStep1';
import PermissionCheckWrapper from './components/PermissionCheckWrapper';
import ProctoringRoom from './pages/ProctoringRoom';
import ProctoringSuccess from './pages/ProctoringSuccess';
import ProctoringViolation from './pages/ProctoringViolation';
import PhoneInterview from './pages/PhoneInterview';
import Intent from './pages/Intent';
import TermsAndConditions from './pages/TermsAndConditions';
import * as Sentry from "@sentry/react";
// import { getCurrentHub } from "@sentry/core";


Sentry.init({
  dsn: "https://98e259b3c784119b64488ff9f9176480@o4509472808042496.ingest.de.sentry.io/4509473054326864",
  environment: 'prompthire.org',    // example: 'production', 'staging'
    
});

// logger.debug('Sentry initialized:', !!Sentry.getCurrentHub().getClient());
// logger.debug('Sentry DSN:', Sentry.getCurrentHub().getClient().getOptions().dsn);

// Sentry.captureMessage('Test message from index.js');

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <Provider store={store}>
      <WebSocketProvider>
        <ToastContainer />
        <Router>
          {/* <PermissionCheckWrapper> */}
            <Routes>
              <Route path="/" element={<App />} />
              <Route path="/start-interview/:id?" element={<InterviewForm />} />
              <Route path="/candidate-feedback/:job_interview_id?" element={<InterviewFeedback />} />
              <Route path="/interview" element={<Interview />} />
              <Route path="/interview/*" element={<Interview />} />
              <Route path="/thankyou" element={<ThankYou />} />
              <Route path="/interview-completed" element={<InterviewCompleted />} />
              <Route path="/stage-react-code" element={<ReactLiveCodeEditor />} />
              <Route path="/secondry-interview" element={<SecondryCamera />} />
              <Route path="/instruction" element={<InterviewFormStep1 />} />
              <Route path="/proctoring" element={<ProctoringRoom />} />
              <Route path="/proctoring-success" element={<ProctoringSuccess />} />
              <Route path="/proctoring-violation" element={<ProctoringViolation />} />
              <Route path="/start-phone-interview/:interview_id?" element={<PhoneInterview />} />
              <Route path="/intent" element={<Intent />} />
              <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          {/* </PermissionCheckWrapper> */}
        </Router>
      </WebSocketProvider>
    </Provider>
  </React.StrictMode>
);
